export const formatNumber = (number: number | string, prefix: string) => {
  const stringNumber = `${number ?? 0}`.trim();
  return `${`${stringNumber}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')?.trim()} ${prefix}`;
};
